import React from 'react';
import little_moto from '../img/little_moto.png'
import drapeau from '../img/drapeau France.svg'

import DataDevis from '../dataDevis';

export default class FrontRecapitulatif extends React.Component {

    constructor(props) {
        super(props);
    }

    /** 
     * @param forceDisplay Display value Oui or Non anyway. 
    */
    staticLabel(field,opt={}) {
        const {forceDisplay,forceLabel} = opt
        const devis = this.props.devis
        const value = devis.getDisplayValue(field) 
        const type = devis.getType(field)
        const label = forceLabel || devis.getLabel(field)
        if ( type == 'ouinon' ) {
            return forceDisplay 
            ? <label>{label} <span>{(value=='O')?'Oui':((value=='N')?'Non':'à définir')}</span></label>
            : (( value == 'O' )?<label>{label}</label>:'')
        } else if (( value==='' )&&( !forceDisplay )) return ''
        if ( typeof type === 'object' ) {
            return <label>{label} <span>{type[value] || '???'}</span></label>
        }
        return <label>{label} <span>{value}</span></label>
    }

    value(field,deflt='') {
        const devis = this.props.devis
        const params = devis.params
        const type = devis.getType(field)
        if ( typeof type === 'object' ) {
            return type[params[field]] || deflt
        }

        return devis.getDisplayValue(field) || deflt
    }

    render() {

        const devis = this.props.devis
        const params = devis.params
        const need_A2 = devis.need_A2()
        const permis_B = params.categorie_permis == 'B'
        const permis_A2 = params.categorie_permis == 'A2'
        const sinistres = this.props.devis.getSinistres()
        return <>
        <div className="contentvbox">
            <h1 className="top_title" ref={this.props.selfRef}>
                Votre véhicule
                <a onClick={()=>this.props.container.setPage('vehicule')}>Modifier</a>
            </h1>
            
            <div className="recap">
                <label>Votre deux-roues <img src={little_moto}/><span>{this.value('marque')} {this.value('modele')} ({this.value('cylindree')})</span></label>
                {this.staticLabel("date_mise_en_circulation")}
                {this.staticLabel("date_acquisition")}
                {this.staticLabel("homologue",{forceDisplay:true})}
                {this.staticLabel("carte_grise_france",{forceDisplay:true})}
                {this.staticLabel("carte_grise_titulaire")}
                {this.staticLabel("usage")}
                {this.staticLabel("assur_23_mois",{forceDisplay:true})}

            </div>


        </div>
        <div className="contentvbox">
            <h1 className="top_title" ref={this.props.selfRef}>
                Vous
                <a onClick={()=>this.props.container.setPage('vous')}>Modifier</a>
            </h1>



            <div className="recap">
                <label>Adresse<span>{this.value('prenom')} {this.value('nom')}<br/>{this.value('adresse2')} {this.value('adresse')}<br/>
                {this.value('code_postal')} {this.value('ville')}</span></label>
                {this.staticLabel("telephone")}
                {this.staticLabel("email")}
                {this.staticLabel("date_naissance")}
                <label>Votre permis
                    <span>{this.value('categorie_permis')} ({this.value('norme_permis')})</span>
                </label>
                {this.staticLabel("date_obtention_permis",{forceLabel:'Obtenu le'})}
                {need_A2 ? <>
                    {this.staticLabel("aussi_permis_A2",{forceDisplay:true})}
                    {this.staticLabel("date_obtention_permis_A2",{forceDisplay:true})}
                </>:''}
                {permis_A2 ? this.staticLabel("bridee_47_5CV") :''}
                {permis_B ? this.staticLabel("formation_F125",{forceLabel:'Vous remplissez les conditions pour conduire ce véhicule avec le permis B',forceDisplay:true}) : ''}
                {need_A2 ? this.staticLabel('permis_A_obtenu_par_formation') : ''}

                {this.staticLabel("antecedant_400cm3_24mois")}
                {this.staticLabel("assure_actuellement")}

                <label>Bonus moto / auto<span>{this.value('coefficient_moto',100)} / {this.value('coefficient_auto',100)}</span></label>
                {(( this.value('coefficient_moto')<=50 )||( this.value('coefficient_auto')<=50 ))
                ?this.staticLabel("bonus_50_plus_3_ans",{forceDisplay:true})
                :''}
                <label>Situation familiale<span>{this.value('situation_famille')}, {this.value('nombre_enfants','0')} enfants</span></label>
            </div>
        </div>
        <div className="contentvbox">
            <h1 className="top_title" ref={this.props.selfRef}>
                Vos antécédents
                <a onClick={()=>this.props.container.setPage('antecedents')}>Modifier</a>
            </h1>
            <div className="recap">
                {this.staticLabel("ant_retrait")}
                {this.staticLabel("ant_annulation")}
                {this.staticLabel("ant_alcool")}
                {this.staticLabel("ant_stupefiants")}
                {this.staticLabel("ant_resiliation")}
                {/*( sinistres.length > 0 )?<><label><u>Avec ce véhicule :</u></label></>:<></>*/}
                {sinistres.map(
                    ( sinistre, idx ) => <label key={idx}>{sinistre.date} : <span>{DataDevis.sinistreTypeToDisplay[sinistre.type]}</span></label>
                )}
                {((params['ant_retrait']=='N')
                    &&(params['ant_annulation']=='N')
                    &&(params['ant_alcool']=='N')
                    &&(params['ant_stupefiants']=='N')
                    &&(params['ant_resiliation']=='N')
                    &&( sinistres.length == 0 ))?<label><span>Aucun antécédent</span></label>:''}
            </div>
        </div>
        <div className="contentvgreenbox">
            <p className="title">
                Besoin d'un conseiller ? <img src={drapeau}/>
            </p>
            <p>
                Contactez nos experts en assurance moto basés en France !
            </p>
            <p className="telephone_left">
            <a href="tel:0974772861">09 74 77 28 61</a>
            </p>

        </div>

        </>
    }
}